import { useLocalObservable } from 'mobx-react-lite';
import { MutableRefObject, useRef } from 'react';

interface IDatePickerReturnType {
  presenter: IDatePickerPresenter;
  anchorRef: MutableRefObject<HTMLButtonElement | null>;
}

interface IDatePickerPresenter {
  isPickerOpen: boolean;
  onSwitchPicker(): void;
  onChange(date: Date): void;
}

interface IDatePickerPresenterProps {
  onChangeDate: (date: Date) => void;
}

export function useDatePickerPresenter(props: IDatePickerPresenterProps): IDatePickerReturnType {
  const { onChangeDate } = props;

  const presenter = useLocalObservable<IDatePickerPresenter>(() => ({
    isPickerOpen: false,

    onSwitchPicker(): void {
      presenter.isPickerOpen = !presenter.isPickerOpen;
    },

    onChange(date: Date): void {
      onChangeDate(date);
      presenter.onSwitchPicker();
    },
  }));

  const anchorRef = useRef<HTMLButtonElement | null>(null);

  return { presenter, anchorRef };
}
